<template>
    <div id="mySidenavLegenda" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #3D405B !important;color: #ffffff;">
                <h3 class="card-title text-white">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                        Legenda Peta
                    </span>
                    <span v-else>
                        Map Legend
                    </span>
                </h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLegenda()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body" style="color: #111 !important;min-height: 100vh;">
                <h6><b id="legendalayer" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Legenda Layer Peta
                        </span>
                        <span v-else>
                            Map Layer Legend
                        </span>
                    </b>
                </h6>
                <ul id="treelegenda" style="cursor: pointer;font-size: small !important;" class="text-black">
                </ul>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavPengaturan" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #3D405B !important;color: #ffffff;">
                <h3 class="card-title text-white">Base Map</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavPengaturan()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body text-black" style="min-height: 100vh;">
                <h6 class="text-black"><b id="pengeturan">Pengaturan Base Map</b></h6>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio111"
                        name="customRadio" value="1" @click="tampilbasemap('customRadio111')">
                    <label for="customRadio111" class="custom-control-label" style="color: #000000;">Google Map
                        (ROADMAP)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio6"
                        name="customRadio" value="6" @click="tampilbasemap('customRadio6')">
                    <label for="customRadio6" class="custom-control-label" style="color: #000000;">Google Map
                        (Hybrid)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio8"
                        name="customRadio" value="8" @click="tampilbasemap('customRadio8')">
                    <label for="customRadio8" class="custom-control-label" style="color: #000000;">Google Map
                        (Terrain)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio22"
                        name="customRadio" value="2" @click="tampilbasemap('customRadio22')" checked="checked">
                    <label for="customRadio22" class="custom-control-label" style="color: #000000;">MapQuest OSM</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio4"
                        name="customRadio" value="4" @click="tampilbasemap('customRadio4')">
                    <label for="customRadio4" class="custom-control-label" style="color: #000000;">Esri World Topo
                        Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio9"
                        name="customRadio" value="9" @click="tampilbasemap('customRadio9')">
                    <label for="customRadio9" class="custom-control-label" style="color: #000000;">ESRI World
                        Imagery</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio10"
                        name="customRadio" value="10" @click="tampilbasemap('customRadio10')">
                    <label for="customRadio10" class="custom-control-label" style="color: #000000;">ESRI World Street
                        Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio11"
                        name="customRadio" value="11" @click="tampilbasemap('customRadio11')">
                    <label for="customRadio11" class="custom-control-label" style="color: #000000;">ESRI Gray
                        Map</label>
                </div>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavLayer" class="sidenav p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #3D405B !important;color: #ffffff;">
                <h3 class="card-title text-white">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                        Layer
                    </span>
                    <span v-else>
                        Layers
                    </span>
                </h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLayer()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body" style="color: #4e5256 !important;min-height: 100vh;">
                <h6><b id="judultransparant" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Transparansi Layer
                        </span>
                        <span v-else>
                            Layer Transparency
                        </span>
                    </b></h6>
                <input id="opacity-input" type="range" min="0" max="1" step="0.01" value="0.75" style="width: 100%;"
                    class="accent" /><span id="opacity-output" style="display: none;"></span>
                <h6><b id="daftarlayer" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Layer
                        </span>
                        <span v-else>
                            List of Layers
                        </span>
                    </b></h6>
                <div class="col-sm-12 float-left pb-2" style="display: none;">
                    <div class="input-group mb-3" v-if="(bahasa === null) || (bahasa == 'ina')">
                        <input id="carikata" placeholder="Masukkan Kata Kunci Pencarian Layer" type="text"
                            class="form-control form-control-sm" style="font-size: small !important;"
                            @change="ambildata()">
                        <div class="input-group-append">
                            <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                    class="fas fa-search"></i></span>
                        </div>
                    </div>
                    <div class="input-group mb-3" v-else>
                        <input id="carikata" placeholder="Enter Layer Search Keywords" type="text"
                            class="form-control form-control-sm" style="font-size: small !important;"
                            @change="ambildata()">
                        <div class="input-group-append">
                            <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                    class="fas fa-search"></i></span>
                        </div>
                    </div>
                </div>
                <ul id="tree1" style="cursor: pointer;font-size: small !important;">
                </ul>
            </div>
        </div>
    </div>
    <div id="myInfoLayer" class="sidenavkanan p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #3D405B !important;color: #ffffff;">
                <h3 class="card-title text-white">Info</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavInfo()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body text-center" id="exceldata">
                <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                    data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_Keterangan_')">
                    <i class="fas fa-download"></i>
                    Unduh Keterangan .xlsx
                </button>
            </div>
            <div class="card-body" style="color: black !important;min-height: 95vh;width: 90%; overflow: auto;"
                id="Info_Adit">
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Resume Proyek
                        </span>
                        <span v-else>
                            Project Resume
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">

                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center"
                    style="position: fixed;left: 0;bottom: 10px;width: 98%;min-height: 100px;">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalunduhdata" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Layer
                        </span>
                        <span v-else>
                            List of Layers
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 250px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Nama Data Layer
                                                    </span>
                                                    <span v-else>
                                                        Data Layer Name
                                                    </span>
                                                </th>
                                                <th style="width: 100px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Opsi
                                                    </span>
                                                    <span v-else>
                                                        Option
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in daftarunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ datalist.nama }}
                                                    </td>
                                                    <td class="text-center">
                                                        <button type="button"
                                                            class="btn btn-success btn-sm lebar2 text-white"
                                                            @click="prosesdata(datalist.namalayer)"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Lihat data.."><i class="fas fa-download"></i>
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lihat data
                                                            </span>
                                                            <span v-else>
                                                                View Data
                                                            </span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="(dataunduhlayer.length > 0)">
                        <div class="card cardputih">
                            <div class="card-body p-2 text-center">
                                <button type="button" class="btn btn-success btn-sm lebar2 text-white"
                                    @click="G_tableCSVTabel2('_DetailData_')" data-toggle="tooltip"
                                    data-placement="left" title="Unduh data (.xlsx).."><i class="far fa-file-excel"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh data (.xlsx)
                                    </span>
                                    <span v-else>
                                        Download Data (.xlsx)
                                    </span>
                                </button><br><br>
                                <span v-show="dataunduhlayer.length == 0">Silahkan Pilih Data .....</span>
                                <center>
                                    <div class="spinner-border text-danger text-center"
                                        style="width: 3rem; height: 3rem;" role="status"
                                        v-show="dataunduhlayer.length == 0">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-show="dataunduhlayer.length == 0">Loading Data .....</span>
                                </center>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadidata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <template v-for="(datajudul, urutjudul) in datajudulunduhlayer"
                                                    :key="urutjudul">
                                                    <th style="width: 150px;">{{ datajudul }}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify" v-for="(dataisi, urutisi) in datalist"
                                                        :key="urutisi">
                                                        {{ dataisi.data }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center"
                    style="position: fixed;left: 0;bottom: 10px;width: 98%;min-height: 100px;">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodal()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalinformasidata" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Informasi Data Layer
                        </span>
                        <span v-else>
                            Data Layer Information
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 250px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Nama Data Layer
                                                    </span>
                                                    <span v-else>
                                                        Data Layer Name
                                                    </span>
                                                </th>
                                                <th style="width: 100px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Opsi
                                                    </span>
                                                    <span v-else>
                                                        Option
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in daftarunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ datalist.nama }}
                                                    </td>
                                                    <td class="text-center">
                                                        <button type="button"
                                                            class="btn btn-success btn-sm lebar2 text-white"
                                                            @click="informasidatalayer(datalist.namalayer)"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Lihat data.."><i class="fas fa-download"></i>
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lihat informasi data
                                                            </span>
                                                            <span v-else>
                                                                View data information
                                                            </span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="(dataunduhlayer.length > 0)">
                        <div class="card cardputih">
                            <div class="card-body p-2 text-center">
                                <button type="button" class="btn btn-success btn-sm lebar2 text-white"
                                    @click="G_tableCSVTabel2('_DetailData_')" data-toggle="tooltip"
                                    data-placement="left" title="Unduh data (.xlsx).."><i class="far fa-file-excel"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh data (.xlsx)
                                    </span>
                                    <span v-else>
                                        Download Data (.xlsx)
                                    </span>
                                </button><br><br>
                                <span v-show="dataunduhlayer.length == 0">Silahkan Pilih Data .....</span>
                                <center>
                                    <div class="spinner-border text-danger text-center"
                                        style="width: 3rem; height: 3rem;" role="status"
                                        v-show="dataunduhlayer.length == 0">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-show="dataunduhlayer.length == 0">Loading Data .....</span>
                                </center>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadidata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <template v-for="(datajudul, urutjudul) in datajudulunduhlayer"
                                                    :key="urutjudul">
                                                    <th style="width: 150px;">{{ datajudul }}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify" v-for="(dataisi, urutisi) in datalist"
                                                        :key="urutisi">
                                                        {{ dataisi.data }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center"
                    style="position: fixed;left: 0;bottom: 10px;width: 98%;min-height: 100px;">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalinformasi()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <svg xmlns="" viewBox="0 5 1440 320">
            <rect x="0" y="0" width="2980" height="100" fill="#3D405B" />
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ nama }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                    }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>
    </section>
    <section class="about-section text-center" style="padding: 0px !important;">
        <div class="row">
            <div class="col-lg-12 col-12 text-center">
                <div class="section-bg-image-block" style="padding: 10px !important;border-radius: 0px !important;">
                    <input type="hidden" id="detaildatamulti" value=""></input>
                    <input type="hidden" id="paramlayerunduh" value=""></input>
                    <input type="hidden" id="paramlayerinformasi" value=""></input>
                    <input type="hidden" id="paramkodecekbox" value=""></input>
                    <input type="hidden" id="isidatakosong" value=""></input>
                    <input type="hidden" class="form-control" id="linknya" name="linknya" placeholder="linknya"
                        :value="linknya">
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Parse Data" @click="parsedatalayer()" id="tombolparamunduh" style="display: none;">
                        <i class="far fa-clone"></i> Parse Data
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Tes Peta" @click="ceklayer()" id="tombolparamkodecekbox" style="display: none;">
                        <i class="far fa-clone"></i> Tes Peta
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Tes Peta" @click="modalfilter()" id="tombolfilterkodecekbox" style="display: none;">
                        <i class="far fa-clone"></i> Filter Peta
                    </button>
                    <button type="button" class="btn btn-tool text-white" data-toggle="tooltip" data-placement="left"
                        title="Data Kosong" @click="datakosonglayer()" id="tomboldatakosong" style="display: none;">
                        <i class="far fa-clone"></i> Data Kosong
                    </button>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Resume Proyek / Project Resume" @click="bukaresume()"
                            style="color: #000000;">
                            <i class="fas fa-chart-area"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Resume Proyek
                            </span>
                            <span v-else>
                                Project Resume
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Layer Peta / Map Layers" @click="openNavLayer()"
                            style="color: #000000;">
                            <i class="far fa-clone"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Layer Peta
                            </span>
                            <span v-else>
                                Map Layers
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Informasi Layer Peta / Map Layer Information"
                            @click="cekdataterpilihinformasi()" style="color: #000000;">
                            <i class="fas fa-align-justify"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Informasi Layer Peta
                            </span>
                            <span v-else>
                                Map Layer Information
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Unduh Data Tabel Peta / Download Map Table Data"
                            @click="cekdataterpilih()" style="color: #000000;">
                            <i class="fas fa-cloud-download-alt"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data Tabel Peta
                            </span>
                            <span v-else>
                                Download Map Table Data
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Basemap Peta / Map Basemap" @click="openNavPengaturan()"
                            style="color: #000000;">
                            <i class="fas fa-cogs"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Basemap Peta
                            </span>
                            <span v-else>
                                Map Basemap
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Legenda Peta / Map Legend" @click="openNavLegenda()"
                            style="color: #000000;">
                            <i class="fas fa-photo-video"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Legenda Peta
                            </span>
                            <span v-else>
                                Map Legend
                            </span>
                        </button>
                        <button type="button" class="btn btn-tool text-black" data-toggle="tooltip"
                            data-placement="left" title="Cetak Peta / Print Map" @click="cetakpeta()"
                            style="color: #000000;">
                            <i class="fas fa-print"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Cetak Peta
                            </span>
                            <span v-else>
                                Print Map
                            </span>
                        </button>
                    </div>
                    <div class="col-lg-12 col-12 text-center">&nbsp;</div>
                    <iframe :src="sourcenya" class="col-lg-12 col-12 text-center" style="min-height: 100vh;"
                        frameborder="0" id="maps" scrolling="no" @load="loadpeta()">
                    </iframe>
                </div>
            </div>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import select2 from 'select2';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import CryptoJS from 'crypto-js';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { useRoute } from 'vue-router';
import { watch } from 'vue';

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            datapesan: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_beranda-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            konten: '',
            nama: '',
            bahasa: localStorage.getItem("bahasasistem"),
            linknya: process.env.VUE_APP_URL_API,
            data_layer: [],
            data_legenda: [],
            kabkot: [],
            datakabkot: [],
            defaultSelectedkabkot: {
                code: 0,
                label: 'Semua Kabupaten/Kota',
                tag: '',
            },
            selectedkabkot: '',
            filter: [],
            datafilter: [],
            defaultSelectedfilter: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedfilter: '',
            paramselectedfilter: [],
            arraynamafilter: [],
            daftarunduhlayer: [],
            dataunduhlayer: [],
            datajudulunduhlayer: [],
            carikata: '',
            nama: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',
        };
    },
    methods: {
        parsedatalayer() {
            this.dataunduhlayer = [];
            this.dataunduhlayer = JSON.parse(document.getElementById('detaildatamulti').value);
            //alert(this.dataunduhlayer.length);
            if (this.dataunduhlayer.length > 0) {
                this.datajudulunduhlayer = [];
                for (let i = 0; i < 1; i++) {
                    for (let x = 0; x < this.dataunduhlayer[i].length; x++) {
                        this.datajudulunduhlayer.push(this.dataunduhlayer[i][x].kolom);
                    }
                }
            }
        },
        informasidatalayer(layer) {
            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                swal.fire({
                    title: "Konfirmasi",
                    text: "Untuk data dalam jumlah besar memerlukan waktu loading yang mungkin lama tergantung kondisi internet dan server, Yakin Hendak Memproses Data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Batal",
                    confirmButtonColor: "#3D405B",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Proses"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerinformasi').value = '';
                        document.getElementById('paramlayerinformasi').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerinformasi').click();
                        this.halamanloading = false;
                    }
                });
            }
            else {
                swal.fire({
                    title: "Confirmation",
                    text: "For large amounts of data, it may take a long time to load, depending on internet and server conditions. Are you sure you want to process the data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#3D405B",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Process"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerinformasi').value = '';
                        document.getElementById('paramlayerinformasi').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerinformasi').click();
                        this.halamanloading = false;
                    }
                });
            }
            $('.swal2-container').css("z-index", '999999');
            return false;
        },
        prosesdata(layer) {
            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                swal.fire({
                    title: "Konfirmasi",
                    text: "Untuk data dalam jumlah besar memerlukan waktu loading yang mungkin lama tergantung kondisi internet dan server, Yakin Hendak Memproses Data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Batal",
                    confirmButtonColor: "#3D405B",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Proses"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerunduh').value = '';
                        document.getElementById('paramlayerunduh').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerunduh').click();
                        this.halamanloading = false;
                    }
                });
            }
            else {
                swal.fire({
                    title: "Confirmation",
                    text: "For large amounts of data, it may take a long time to load, depending on internet and server conditions. Are you sure you want to process the data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#3D405B",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Process"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerunduh').value = '';
                        document.getElementById('paramlayerunduh').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerunduh').click();
                        this.halamanloading = false;
                    }
                });
            }
            $('.swal2-container').css("z-index", '999999');
            return false;

        },
        tutupmodalinformasi() {
            $('#costumModalinformasidata').modal('hide');
        },
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        tutupmodal() {
            $('#costumModalunduhdata').modal('hide');
        },
        tutupmodalalokasi() {
            $('#costumModalalokasi').modal('hide');
        },
        bukaresume() {
            $('#costumModalresume').modal('show');
        },
        async cekdataterpilihinformasi() {
            this.daftarunduhlayer = [];
            this.dataunduhlayer = [];
            var inputs = document.querySelectorAll("input[type='checkbox']");
            var checkboxesChecked = [];
            for (var i = 0; i < inputs.length; i++) {
                // And stick the checked ones onto an array...
                if (inputs[i].checked) {
                    var temp = inputs[i].id.split("|");
                    if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": 'Layer ' + temp[4],
                        });
                    }
                    else {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": temp[35] + ' Layer',
                        });
                    }
                }
            }
            if (checkboxesChecked.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data layer yang akan diunduh datanya belum dipilih, silahkan pilih dari menu layer peta',
                });
                return false;
            }
            this.daftarunduhlayer = checkboxesChecked;
            $('#costumModalinformasidata').modal('show');
            //alert(JSON.stringify(checkboxesChecked));
        },
        async cekdataterpilih() {
            this.daftarunduhlayer = [];
            this.dataunduhlayer = [];
            var inputs = document.querySelectorAll("input[type='checkbox']");
            var checkboxesChecked = [];
            for (var i = 0; i < inputs.length; i++) {
                // And stick the checked ones onto an array...
                if (inputs[i].checked) {
                    var temp = inputs[i].id.split("|");
                    if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": 'Layer ' + temp[4],
                        });
                    }
                    else {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": temp[35] + ' Layer',
                        });
                    }
                }
            }
            if (checkboxesChecked.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data layer yang akan diunduh datanya belum dipilih, silahkan pilih dari menu layer peta',
                });
                return false;
            }
            this.daftarunduhlayer = checkboxesChecked;
            $('#costumModalunduhdata').modal('show');
            //alert(JSON.stringify(checkboxesChecked));
        },
        async G_tableCSVTabel1(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('customers2'), { sheet: "DataLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        async G_tableCSVTabel2(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('tabeldataadidata'), { sheet: "DataDetailLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        onkabkotChange(a) {
            try {
                this.selectedkabkot = this.kabkot[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ceklayer() {
            var cekbox = document.getElementById('paramkodecekbox').value;
            if (document.getElementById(cekbox).checked == true) {
                this.loadpeta();
            }
            else {
                this.loadpeta();
            }
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        kembali() {
            window.location.replace("/");
        },
        closeNavInfo() {
            document.getElementById("myInfoLayer").style.width = "0";
        },
        openNavLayer() {
            this.closeNavPengaturan();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavLayer").style.width == "380px") {
                document.getElementById("mySidenavLayer").style.width = "0";
            } else {
                document.getElementById("mySidenavLayer").style.width = "380px";
            }
        },
        closeNavLayer() {
            document.getElementById("mySidenavLayer").style.width = "0";
        },
        openNavPengaturan() {
            this.closeNavLayer();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavPengaturan").style.width == "380px") {
                document.getElementById("mySidenavPengaturan").style.width = "0";
            } else {
                document.getElementById("mySidenavPengaturan").style.width = "380px";
            }
        },
        closeNavPengaturan() {
            document.getElementById("mySidenavPengaturan").style.width = "0";
        },
        openNavLegenda() {
            this.closeNavPengaturan();
            this.closeNavLayer();
            if (document.getElementById("mySidenavLegenda").style.width == "380px") {
                document.getElementById("mySidenavLegenda").style.width = "0";
            } else {
                document.getElementById("mySidenavLegenda").style.width = "380px";
            }
        },
        closeNavLegenda() {
            document.getElementById("mySidenavLegenda").style.width = "0";
        },
        cetakpeta() {
            document.getElementById("maps").contentWindow.document.getElementById("export-png").click();
        },
        tampilbasemap(tipenya) {
            document.getElementById("maps").contentWindow.document.getElementById(tipenya).click();
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async ambildata() {
            //alert(this.iduser);
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {
                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }
                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };


                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                //var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }
                                node.appendChild(textnode);
                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("tree1").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("tree1").appendChild(node);
                                    }
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {

                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }

                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                //var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }
                                node.appendChild(textnode);
                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                //document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#tree1').treed();

                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("treelegenda").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }

                                node.appendChild(textnode);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("treelegenda").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("treelegenda").appendChild(node);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {
                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                //alert(this.data_layer[i].id);
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                node.appendChild(textnode);
                                if ((this.data_layer[i].jenis == '2') && (this.data_layer[i].legenda != '')) {
                                    //alert(atob(this.data_layer[i].legenda));
                                    //return;
                                    var arraylegenda = JSON.parse(atob(this.data_layer[i].legenda));
                                    //alert(arraylegenda.length);

                                    for (var z = 0; z < arraylegenda.length; z++) {
                                        // awal legenda
                                        if ((arraylegenda[z].keterangan == 'gambar') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Point')) {
                                            // awal gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);

                                            var gambar = document.createElement('img');
                                            if (arraylegenda[z].kolom.toString().trim().includes("http")) {
                                                gambar.src = arraylegenda[z].kolom;
                                            }
                                            else {
                                                gambar.src = this.linknya + 'maps_parastapainnovation-Ikon?f=' + arraylegenda[z].kolom;
                                            }

                                            gambar.style.height = '15px';
                                            //nodelegenda.appendChild(gambar);
                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(gambar);
                                            nodelegenda.appendChild(buttonlihat);

                                            if (arraylegenda[z].keterangan.toString().trim().toUpperCase().includes("SESUAI")) {
                                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer + " ");
                                                }
                                                else {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer_eng + " ");
                                                }
                                            }

                                            else {
                                                var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            }

                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);

                                            // akhir gambar
                                        }
                                        else {
                                            // awal bukan gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);
                                            var iclassbuttonlihat = document.createElement("i");
                                            iclassbuttonlihat.classList.add("fas");
                                            if ((arraylegenda[z].keterangan == 'fill') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Polygon') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Radius')) {
                                                if ((arraylegenda[z].tipe_fill == 'Pattern')) {
                                                    if ((arraylegenda[z].tipe_pattern == 'crosses') || (arraylegenda[z].tipe_pattern == '6')) {
                                                        iclassbuttonlihat.classList.add("fa-chess-board");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'cross') || (arraylegenda[z].tipe_pattern == '2')) {
                                                        iclassbuttonlihat.classList.add("fa-border-all");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'hatch') || (arraylegenda[z].tipe_pattern == '1')) {
                                                        iclassbuttonlihat.classList.add("fa-bars");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'dot') || (arraylegenda[z].tipe_pattern == '3')) {
                                                        iclassbuttonlihat.classList.add("fa-qrcode");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'brick') || (arraylegenda[z].tipe_pattern == '4')) {
                                                        iclassbuttonlihat.classList.add("fa-compress");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'wave') || (arraylegenda[z].tipe_pattern == '5')) {
                                                        iclassbuttonlihat.classList.add("fa-water");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'rock') || (arraylegenda[z].tipe_pattern == '7')) {
                                                        iclassbuttonlihat.classList.add("fa-grip-horizontal");
                                                    }
                                                    else {
                                                        iclassbuttonlihat.classList.add("fa-object-group");
                                                    }
                                                }
                                                else {
                                                    iclassbuttonlihat.classList.add("fa-square-full");
                                                }
                                            }
                                            else {
                                                if (arraylegenda[z].isian.toString().trim().toUpperCase().includes("SUNGAI")) {
                                                    iclassbuttonlihat.classList.add("fa-signature");
                                                }
                                                else {
                                                    iclassbuttonlihat.classList.add("fa-minus");
                                                }

                                            }
                                            //iclassbuttonlihat.classList.add("fa-signature");
                                            //iclassbuttonlihat.classList.add("fa-bacon");
                                            //iclassbuttonlihat.classList.add("fa-square-full");
                                            //iclassbuttonlihat.classList.add("fa-chess-board");
                                            //iclassbuttonlihat.classList.add("fa-border-all");

                                            iclassbuttonlihat.style.color = arraylegenda[z].kolom;
                                            //iclassbuttonlihat.classList.add("text-info");

                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(iclassbuttonlihat);
                                            nodelegenda.appendChild(buttonlihat);

                                            if (arraylegenda[z].keterangan.toString().trim().toUpperCase().includes("SESUAI")) {
                                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer + " ");
                                                }
                                                else {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer_eng + " ");
                                                }
                                            }

                                            else {
                                                var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            }
                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);
                                            // akhir bukan gambar
                                        }
                                        // akhir legenda


                                    }
                                }


                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                //ul.appendChild(ullegenda);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#treelegenda').treed();
                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                console.log(error);
                this.halamanloading = false;
            });

            const mainAPI3 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI3.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=6").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.nama = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });
        },
        loadpeta() {
            this.halamanloading = true;
            try {
                var tempceknya = document.getElementById('paramkodecekbox').value;
                var ceknya = document.getElementById(tempceknya).checked;
                try {
                    this.selectedfilter = document.getElementById('select' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedfilter = '';
                }
                try {
                    this.selectedradius = document.getElementById('radius' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedradius = '0';
                }

                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            } catch (error) {
                var ceknya = false;
                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            }
            //alert(this.selectedfilter);
            const message = messagetemp;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/gis.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        koordinatkosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Koordinat belum diisi..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        datakosonglayer() {
            this.halamanloading = false;
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer ' + document.getElementById('isidatakosong').value + ' Tidak Tersedia..',
            });
            $('.swal2-container').css("z-index", '999999');

        },
        datakosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer Gagal Diunduh..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        openNavInfoBawah() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuanj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        openNavInfoBawahKec() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuankecj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        openNavInfoBawahDesa() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuandesaj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.JustClearlocalStorage();
            }
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildatareff();
        this.ambildata();
        this.InisialisasiTree();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>